import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { messengerSettingsActions as actions } from '../../../../messengerSettings.actions';
import { selectKnowledgeState } from '../../../../messengerSettings.selectors';
import { ElevioIntegration, MessengerConnectElevioModal } from './components';
/**
 * Knowledge settings component used to configure Elevio integration with the
 * messenger
 */
export function Knowledge({}) {
    const knowledgeState = useAppSelector(selectKnowledgeState);
    const dispatch = useAppDispatch();
    const handleEditElevioAccountId = () => {
        dispatch(appActions.showModal({
            modal: { type: 'settings:messengerConnectElevio' },
        }));
    };
    const handleToggleElevioIntegration = () => {
        dispatch(actions.toggleElevioIntegration());
    };
    const handleUpdateDisplayType = (displayType) => {
        dispatch(actions.updateDisplayType(displayType));
    };
    const handleLanguageChange = (language) => {
        dispatch(actions.changeSelectedLanguage(language));
    };
    const handleTranslatedStringChange = (translatable, language, value) => {
        dispatch(actions.updateTranslatedString({ translatable, language, value }));
    };
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "400" }, { children: [_jsx(ElevioIntegration, { state: knowledgeState.elevioIntegration, selectedLanguage: knowledgeState.selectedLanguage, onEditElevioAccountId: handleEditElevioAccountId, onToggleElevioIntegration: handleToggleElevioIntegration, onUpdateDisplayType: handleUpdateDisplayType, onLanguageChange: handleLanguageChange, onTranslatedStringChange: handleTranslatedStringChange }), _jsx(MessengerConnectElevioModal, {})] })));
}
